import { onStartup as onStartupCore } from '../../inplant-core-fe'

export async function onStartup(): Promise<void> {
  await onStartupCore()

  return
}